import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { FrontPageType } from '@appTypes/frontPageType';
import { Actions, actions } from '@redux/modules/frontPage';
import { TypedEpic } from './types';

export const fetchDocumentEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_FRONT_PAGE),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getFrontPage.request>[]
    >,
    switchMap(([action]) => {
      const abTestWeight = action.meta?.abTestWeight?.toString();

      const headers: Record<string, string> = {
        credentials: 'include',
        ...(abTestWeight && { 'X-Ab-Test-Weight': abTestWeight }),
      };

      return fromApiRequest((signal) =>
        apiClient.get<FrontPageType>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].frontpage,
          headers,
        }),
      ).pipe(
        map((response) => actions.getFrontPage.success(response.data)),
        catchError((err) => of(actions.getFrontPage.failure(toReduxError(err, 'Could not get document')))),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchDocumentEpic];
